module.exports = __webpack_public_path__ + "img/apple-iphone-xs.a5faa5ba.jpg";